module.exports = __webpack_public_path__ + "static/media/eclipse2.a2930372.jpg";